import { ComponentLoader } from '../../webana';

import { CommissionDetail } from './components/CommissionDetail';
import { EmployeeDivider } from './components/EmployeeDivider';
import { PDFBatchButton } from './components/PDFBatchButton';
import { ContractCopy } from './components/ContractCopy';

export const components: { [key: string]: ComponentLoader } = {
  'sezako:CommissionDetail': async () => CommissionDetail,
  'sezako:EmployeeDivider': async () => EmployeeDivider,
  'sezako:PDFBatchButton': async () => PDFBatchButton,
  'sezako:ContractCopy': async () => ContractCopy
};



// WEBPACK FOOTER //
// ./src/modules/sezako/index.ts